module.exports=function(scope){ return `// Signal to the FaceTec SDK that audit trail should be captured
ZoomSDK.setAuditTrailType(ZoomAuditTrailType.HEIGHT_640);

// Capture a User Session
Intent sessionIntent = new Intent(this, ZoomSessionActivity.class);
startActivityForResult(sessionIntent, ZoomSDK.REQUEST_CODE_SESSION);

// Sample code to handle the session result
private void handleZoomSessionResult(ZoomSessionResult result) {

    // Capture not successful
    if(result.getStatus() != ZoomSessionStatus.USER_PROCESSED_SUCCESSFULLY) {
        // Handle results here
        return;
    }

    if(result.getFaceMetrics() != null) {
        // Get the audit trail image(s) if available
        ArrayList<Bitmap> auditTrail = result.getFaceMetrics().getAuditTrail();
        stringBuilder.append("number of of Audit Trail Images: ");
        stringBuilder.append(auditTrail.size());
        // Get the auidt trail history if available
        ArrayList<ArrayList<Bitmap>> auditTrailHistory = result.getFaceMetrics().getAuditTrailHistory();
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/android/19-audit-trail.java.tpl